import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import router from '../router';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { cleanObject } from '@/utils/utils';

var url = process.env.VUE_APP_API_URL;
var urlEs = process.env.VUE_APP_ES_URL;

const service = axios.create({
  // process.env.NODE_ENV === 'development' //来判断是否开发环境
  // baseURL: url,
  timeout: 120000,
});

service.interceptors.request.use(
  (config) => {
    if (config.isEs) {
      config.url = urlEs + config.url;
    } else {
      config.url = url + config.url;
    }
    if (localStorage.getItem('token')) {
      config.headers['Bg-token'] = localStorage.getItem('token');
      config.headers['Menu-id'] = localStorage.getItem('menu_id')
        ? localStorage.getItem('menu_id')
        : '0';
      config.headers['menu-log-id'] = localStorage.getItem('menu_id')
        ? localStorage.getItem('menu_id')
        : '0';
    }
    config.data = { data: encrypt(JSON.stringify(cleanObject(config.data))) };
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      if (response.data.data) {
        response.data.data = JSON.parse(decrypt(response.data.data));
      }
      return response.data;
    } else if (response.status == 401) {
      //未授权，未登录
      MessageBox.confirm(
        '您已注销，您可以点击取消以停留在此页，或重新登录',
        '注销确认',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            done();
          },
        }
      ).then(() => {
        localStorage.removeItem('token');
        router.push('/');
      });
    } else if (response.status == 403) {
      //已登录，无权限
      Message.error('您没有权限访问该页面');
      localStorage.removeItem('token');
      router.push('/');
    } else {
      Promise.reject();
    }
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);

export default service;
